import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=a7ddfa0c&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style0 from "./menu.vue?vue&type=style&index=0&id=a7ddfa0c&lang=scss"
import style1 from "./menu.vue?vue&type=style&index=1&id=a7ddfa0c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ddfa0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7ddfa0c')) {
      api.createRecord('a7ddfa0c', component.options)
    } else {
      api.reload('a7ddfa0c', component.options)
    }
    module.hot.accept("./menu.vue?vue&type=template&id=a7ddfa0c&scoped=true", function () {
      api.rerender('a7ddfa0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/menu.vue"
export default component.exports